import { Editor } from 'slate';
import { CustomEditor } from '../../../global';
import { TextFormat } from '../rich-editor-types';

export const isMarkActive = (editor: CustomEditor, format: TextFormat) => {
  const marks = Editor.marks(editor);

  return marks ? !!marks[format] === true : false;
};
